export const buttonStyleEnum = {
  cancel: 'cancel',
  confirm: 'confirm',
  error: 'error',
  warning: 'warning'
}
